// extracted by mini-css-extract-plugin
export default {"error":"styles_error__+ucS2","fadeIn":"styles_fadeIn__ily12"};